import Model from './Model'

export default class Proover extends Model {
  id: number
  identifier: string
  updatedAt: string
  imagePath: string
  informations: any
  firstName: string = null
  lastName: string = null
  phoneNumber: string = null
  company: string = null
  email: string = null
  fullName: string = null

  constructor(json, locale) {
    super({})
    this.id = json.id
    this.identifier = json.identifier
    this.updatedAt = json.updated_at
    this.imagePath = json._picture ? json._picture.path : null
    this.informations = json.infos

    this.parseInfos(json.infos)
  }

  parseInfos(infos) {
    infos.forEach((info) => {
      switch (info.name) {
        case 'first_name':
          this.firstName = info.value
          break
        case 'name':
          this.lastName = info.value
          break
        case 'company':
          this.company = info.value
          break
        case 'email':
          this.email = info.value
          break
        case 'phone_number':
          this.phoneNumber = info.value
          break
      }
    })

    if (this.firstName && this.lastName) {
      this.fullName = `${this.firstName} ${this.lastName}`
    }
  }
}
